import React from 'react';
import './TalentCard.css'; 

const MissionCard = ({ missions = [] }) => {
  return (
    <div className="talent-card">
      <h3>Missions suggérées</h3>
      {missions.length === 0 ? (
        <p className="no-talent">Aucune mission suggérée pour le moment.</p>
      ) : (
        <ul className="talent-list">
          {missions.map((mission, index) => (
            <li key={index} className="talent-item">
              <div className="talent-name">{mission.nom}</div>
              <div className="talent-job">{mission.poste || mission.description}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MissionCard;
